import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, change, stopAsyncValidation } from 'redux-form';
import { t } from 'i18next';
import {
  addressValidate, isRequired, maxAddressLine1, maxChar100,
} from '../../../utils/validator';
import zipPlus4ToZip from './helpers';
import { AddressDiv, FieldLabel } from './css';
import AddressInput from '../../../lib/ui/form_elements/AddressInput';
import Tooltip from '../../../lib/ui/form_elements/Tooltip';

const loadScriptAsync = function loadScriptAsync(uri, elementID) {
  return new Promise((resolve) => {
    const tag = document.createElement('script');
    tag.id = elementID;
    tag.src = uri;
    tag.async = true;
    tag.onload = () => {
      resolve();
    };

    tag.onerror = () => {
      document.getElementById(elementID).parentNode.removeChild(tag);
      loadScriptAsync(uri, elementID);
    };

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  });
};

const loadStyleSheetAsync = function loadStyleSheetAsync(href, elementID) {
  return new Promise((resolve) => {
    const tag = document.createElement('link');
    tag.id = elementID;
    tag.rel = 'styleSheet';
    tag.href = href;
    tag.type = 'text/css';
    tag.async = true;
    tag.onload = () => {
      resolve();
    };

    tag.onerror = () => {
      document.getElementById(elementID).parentNode.removeChild(tag);
      loadStyleSheetAsync(href, elementID);
    };

    const firstLinkTag = document.getElementsByTagName('link')[0];
    firstLinkTag.parentNode.insertBefore(tag, firstLinkTag);
  });
};

class AddressComplete extends PureComponent {
  componentDidMount() {
    this.addressApiInit();
  }

  addressApiInit = async () => {
    if (!global.CPscriptLoaded) {
      global.CPscriptLoaded = loadScriptAsync('https://ws1.postescanada-canadapost.ca/js/addresscomplete-2.30.min.js', 'CPScript');
    }

    global.CPscriptLoaded.then(() => {
      if (!global.CPstyleLoaded) {
        global.CPstyleLoaded = loadStyleSheetAsync('https://ws1.postescanada-canadapost.ca/css/addresscomplete-2.30.min.css', 'CPStyle');
      }

      return global.CPstyleLoaded;
    }).then(() => {
      const { dispatch, formName, fieldName } = this.props;

      const shipperAddressFields = [
        { element: fieldName, field: '', mode: global.pca.fieldMode.SEARCH },
      ];
      const options = {
        key: t('CanadaPostAddressCompleteApiKey'),
        countries: { codesList: 'CAN, USA' },
      };

      // Decorate field whose "name" and / or "id" matches shipperAddressFields elements' "element" attribute...
      const addressElement = new global.pca.Address(shipperAddressFields, options);

      // addressElement.onChange() =>
      addressElement.listen('populate', async (address) => {
        // Formatting pieces that will make up the field value, given country, ...
        let postalCode = '';
        let countryName = '';
        if (address.CountryIso2 === 'US') {
          postalCode = zipPlus4ToZip(address.PostalCode);
          countryName = address.CountryIso3;
        } else {
          postalCode = address.PostalCode;
          countryName = address.CountryName;
        }

        // Format field value...
        const formattedAddress = `${address.Line1}, ${address.City}, ${address.ProvinceCode} ${postalCode}, ${countryName}`;

        // Update redux form field value...
        dispatch(change(formName, fieldName, formattedAddress));
        if (this.props.validator) {
          try {
            await this.props.validator();
          } catch (e) {
            dispatch(stopAsyncValidation(formName, e));
          }
        }
      });
    });
  };

  render() {
    const isOptionalField = this.props.validateData ? [maxAddressLine1] : [isRequired, maxAddressLine1, maxChar100, addressValidate];
    const finalAddress = this.props.tooltipRequired ? (
      <AddressDiv>
        <FieldLabel>
          {this.props.label || t('Address')}
          <Tooltip message={t('TipAddressDetails')} shipmentsFlow={this.props.shipmentsFlow} userFlow={this.props.userFlow} />
        </FieldLabel>
        <Field
          id={this.props.fieldName}
          component={AddressInput}
          name={this.props.fieldName}
          validate={isOptionalField} // onChange validation...
          showErrorAlways={this.props.showErrorAlways}
          required={this.props.required}
          maxLength={100}
          optional={!this.props.required}
        />
      </AddressDiv>
    ) : (
      <Field
        id={this.props.fieldName}
        component={AddressInput}
        name={this.props.fieldName}
        label={this.props.label || t('Address')}
        validate={isOptionalField} // onChange validation...
        showErrorAlways={this.props.showErrorAlways}
        required={this.props.required}
        maxLength={100}
        optional={!this.props.required}
      />
    );
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>{ finalAddress }</>
    );
  }
}

AddressComplete.propTypes = {
  dispatch: PropTypes.func,
  formName: PropTypes.string,
  fieldName: PropTypes.string,
  validateData: PropTypes.bool,
  tooltipRequired: PropTypes.bool,
  label: PropTypes.string,
  shipmentsFlow: PropTypes.string,
  userFlow: PropTypes.string,
  showErrorAlways: PropTypes.bool,
  required: PropTypes.bool,
  validator: PropTypes.func,
};

export default connect()(AddressComplete);
